// Main.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AppLayout from "./components/AppLayout";
import Category from "./pages/Category";
import SunEditorWithPreview from "./components/RichTextEditor";
import Module from "./pages/Module";
import SubModule from "./pages/SubModule";
import Chapter from "./pages/Chapter";
import ChapterSlides from "./pages/ChapterSlides";
import McqsPage from "./pages/McqsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Profile from "./pages/Profile";
import Feedback from "./pages/Feedback";
import ChangePassword from "./pages/ChangePassword";
import Users from "./pages/User";
import Notification from "./pages/Notification";

// ✅ single place to decide if user is logged in
const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  const expiry = Number(localStorage.getItem("expiry")); // you set this on login

  const valid =
    !!token &&
    Number.isFinite(expiry) &&
    Date.now() < expiry; // not expired

  if (!valid) {
    // cleanup any stale keys so state is consistent when storage is cleared
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("expiry");
  }
  return valid;
};

const Main = () => {
  const isLoggedIn = isAuthenticated();

  return (
    <BrowserRouter>
      <Routes>
        {/* Public route: Login */}
        <Route
          path="/"
          element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <Login />}
        />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<AppLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="chapter-slide/:id" element={<SunEditorWithPreview />} />
            <Route path="specialities" element={<Category />} />
            <Route path="module" element={<Module />} />
            <Route path="sub-module" element={<SubModule />} />
            <Route path="chapter" element={<Chapter />} />
            <Route path="chapter-slides" element={<ChapterSlides />} />
            <Route path="mcqs" element={<McqsPage />} />
            <Route path="my-profile" element={<Profile />} />
            <Route path="feedbacks" element={<Feedback />} />
            <Route path="notification" element={<Notification />} />
            <Route path="users" element={<Users />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Main;
